// Modules
import styled from 'styled-components';

// Types
import { styledComponentProps } from '../../types/theme';

export const Content = styled.div`
	margin-top: 100px;
	display: flex;
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
		flex-direction: column;
		margin-top: 65px;
	}
`;
